import {ReactNode} from 'react';

import {Box, Skeleton, SxProps, Theme} from '@mui/material';

const baseStatsGridContainerSx: SxProps<Theme> = {
  display: 'grid',
  width: '100%',
  mb: 3,
  gap: '24px',
  gridTemplateColumns: {
    xs: '1fr',
    sm: 'repeat(auto-fit, minmax(160px, 1fr))',
  },
};

type Props = {
  children?: ReactNode;
  loading?: boolean;
  skeletonCount?: number;
  skeletonHeight?: number;
  sx?: SxProps<Theme>;
};

export const StatsGridContainer = ({
  children,
  loading,
  skeletonCount = 4,
  skeletonHeight = 127,
  sx,
}: Props) => {
  const gridSx = (sx ? [baseStatsGridContainerSx, sx] : baseStatsGridContainerSx) as SxProps<Theme>;

  if (loading) {
    return (
      <Box sx={gridSx}>
        {Array.from({length: skeletonCount}, (_, index) => (
          <Skeleton key={index} variant='rounded' height={skeletonHeight} sx={{width: '100%', minWidth: 0}} />
        ))}
      </Box>
    );
  }

  return <Box sx={gridSx}>{children}</Box>;
};
